import React from "react";
import { Tooltip } from "antd";

const FLAG_SIZE = "27px";

// Pure — the flag SVG badge + tooltip. SVG copied from the cell (fill red, y=46%).
export const FlagBadge = ({ count, tooltip }) => (
    <Tooltip title={tooltip}>
        <div className="stv2-tracker-cell-flag-container">
            {count > 0 ? (
                <svg
                    fill="#000000"
                    width={FLAG_SIZE}
                    height={FLAG_SIZE}
                    viewBox="0 0 256 256"
                    id="Flat"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M217.78906,44.42639a4.00624,4.00624,0,0,0-4.18945.37793c-30.15039,22.61426-56.31934,11.39746-84.02441-.47656C101,32.08166,71.4502,19.4176,37.59961,44.80432c-.07227.0542-.12744.12158-.19482.17944a4.0389,4.0389,0,0,0-.31006.2854c-.08936.09522-.167.19629-.2461.29834-.0791.10254-.15771.20411-.227.31446s-.12744.22461-.18506.34033c-.0581.11621-.11523.2312-.16211.35327-.04638.12207-.08056.24609-.11523.37158-.03369.12329-.06836.24536-.09033.37329a4.01251,4.01251,0,0,0-.043.42627c-.00537.08692-.02588.16944-.02588.25782v168a4,4,0,0,0,8,0V170.05579c29.47852-21.042,55.21191-10.0376,82.4248,1.62548,16.43653,7.04395,33.19434,14.22657,50.90821,14.22657,13.082-.001,26.6875-3.91895,41.06738-14.70313A4.00206,4.00206,0,0,0,220,168.00452v-120A4.0023,4.0023,0,0,0,217.78906,44.42639ZM212,165.97522c-29.47852,21.041-55.21289,10.01562-82.4248-1.64746-26.75977-11.468-54.37452-23.29932-85.5752-3.908V50.05579c29.47852-21.042,55.21191-10.0376,82.4248,1.62548,26.76075,11.46778,54.376,23.30078,85.5752,3.91114Z" />
                    <text
                        x="50%"
                        y="46%"
                        dominantBaseline="middle"
                        textAnchor="middle"
                        fill="red"
                        fontSize="88px"
                        fontWeight="bold"
                    >
                        {count}
                    </text>
                </svg>
            ) : (
                <></>
            )}
        </div>
    </Tooltip>
);
